import { Fields } from '~/core/shared/types';
import { BOOLEAN_FIELD_EMPTY_LABEL } from '../../constants/booleanFieldLabels';
import { getBooleanFieldLabels } from '../../logic/getBooleanFieldLabels';

export const useBooleanFieldValue = (field: Fields.Boolean) => {
  if (field.value === null) {
    return {
      label: BOOLEAN_FIELD_EMPTY_LABEL,
    };
  }

  const { truthyLabel, falsyLabel } = getBooleanFieldLabels(field.meta?.labels);
  const label = field.value ? truthyLabel : falsyLabel;

  return {
    label,
  };
};
